import { inject, Injectable } from '@angular/core';
import { Router } from '@angular/router';
import {
  type IManagementTool,
  type IToolRunContext,
} from '../models/management-tool';

@Injectable({ providedIn: 'root' })
export class NavigateOrganisationsTool implements IManagementTool {
  private _router = inject(Router);

  readonly name = 'navigate-organisations';
  readonly label = 'Organisations';
  readonly icon = 'corporate_fare';
  readonly description = 'Navigate to the organisations management page';

  async run(_context: IToolRunContext): Promise<void> {
    await this._router.navigate(['/management/organisations']);
  }
}
